var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#44C587",
    stroke: "#52B485"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8658 8.48136C16.1387 8.34718 16.4879 8.39093 16.7172 8.59151C16.8898 8.73448 16.99 8.95284 17 9.17569V9.21612C16.9908 9.32667 16.9695 9.438 16.9195 9.5378C16.8625 9.66105 16.7658 9.75909 16.6703 9.85323C14.8408 11.6825 13.0119 13.5124 11.1822 15.3415C11.0379 15.4898 10.8404 15.5884 10.6316 15.5946C10.4023 15.6073 10.1768 15.5081 10.0178 15.3452C9.11934 14.4482 8.22207 13.5497 7.32402 12.6523C7.23125 12.561 7.13867 12.4651 7.08242 12.3464C7.03242 12.2476 7.01074 12.1378 7 12.0286V11.9603C7.01855 11.6794 7.18828 11.4128 7.44355 11.2905C7.66309 11.18 7.93418 11.1819 8.15234 11.295C8.2918 11.3636 8.39629 11.4817 8.50488 11.5894C9.20195 12.2868 9.9002 12.9835 10.5967 13.6817C12.2363 12.0468 13.8717 10.4073 15.51 8.77062C15.6176 8.66222 15.725 8.54659 15.8658 8.48136Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.3a6f3392ae4f33cbf3d045b7bcf1437e.svg";
export { ForwardRef as ReactComponent };